import { render, staticRenderFns } from "./ToxicHabitForm.vue?vue&type=template&id=07e18d4e&"
import script from "./ToxicHabitForm.vue?vue&type=script&lang=js&"
export * from "./ToxicHabitForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports